'use client';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { cn } from '../../utils/cn';
import { radioTheme } from './theme';
export const Radio = forwardRef(({ className, color = 'primary', variant = 'rounded', ...props }, ref) => {
    return (_jsxs(_Fragment, { children: [_jsx("input", { ref: ref, ...props, type: "radio", className: cn(radioTheme.input) }), _jsx("button", { className: cn(radioTheme.button.base, radioTheme.button.variant[variant], radioTheme.button.color[color], className) })] }));
});
Radio.displayName = 'Radio';
